export default {
  first_name: "string",
  last_name: "string"
}



// WEBPACK FOOTER //
// ./src/store/models/user.js